import dynamic from 'next/dynamic';
import { useDispatch, useSelector } from 'react-redux';
import ModalType from 'src/constants/modalTypes';
import { closeModal } from 'src/modules/shared/modal/actions';
import { State } from 'src/types';

// Old
const Modal = dynamic(() => import('./modal'), { ssr: false });
const ConfirmModal = dynamic(() => import('./confirmModal'), { ssr: false });
const DFPModal = dynamic(() => import('src/modules/shared/modal/components/dfpModal'), { ssr: false });
const EmailConfirmationModal = dynamic(() => import('./emailConfirmationModal'), { ssr: false });
const ExistingLoginSocialModal = dynamic(() => import('./signup/existingLoginSocialModal'), { ssr: false });
const FilterOptionsModal = dynamic(() => import('src/modules/search/posts/components/filterOptionsModal'), { ssr: false });
const HuLocalSignupModal = dynamic(() => import('./signup/huLocalSignupModal'), { ssr: false });
const LoginModal = dynamic(() => import('./login/loginModal'), { ssr: false });
const PrivacyTipsModal = dynamic(() => import('src/modules/shared/modal/components/privacyTipsModal'), { ssr: false });
const FeedbackModal = dynamic(() => import('src/modules/shared/feedback/feedbackModal'), { ssr: false });
const SearchSortByModal = dynamic(() => import('src/modules/community/communitySearch/components/sortByModal'), { ssr: false });
const SentimentFeedbackModal = dynamic(() => import('src/modules/shared/feedback/sentimentFeedbackModal'), { ssr: false });
const SignupModal = dynamic(() => import('./signup/signupModal'), { ssr: false });
const SignupSurvey = dynamic(() => import('./signup/signupSurvey'), { ssr: false });
const SimilarToMeTipsModal = dynamic(() => import('src/modules/shared/modal/components/similarToMeTipsModal'), { ssr: false });
const TagFilterOptionsModal = dynamic(() => import('src/pages/tag/tagFilterOptionsModal'), { ssr: false });

// New
const CommunityGuidelinesModal = dynamic(() => import('src/modules/community/shared/components/communityGuidelinesModal'), { ssr: false });
const CommunityInvitesModal = dynamic(() => import('src/modules/shared/modal/components/communityInvites/communityInvitesModal'), { ssr: false });
const CommunityRemoveMemberModal = dynamic(() => import('src/modules/shared/modal/components/communityRemoveMemberModal'), { ssr: false });
const CommunityTopConditionsModal = dynamic(() => import('src/modules/profileSurvey/components/communityTopConditionsModal'), { ssr: false });
const CompletedProgramModal = dynamic(() => import('src/modules/programs/components/completedProgramModal'), { ssr: false });
const ContactAdminsModal = dynamic(() => import('src/modules/shared/modal/components/contactAdminsModal'), { ssr: false });
const DeletePostModal = dynamic(() => import('src/modules/community/singlePost/components/deletePostModal'), { ssr: false });
const EditBadgesModal = dynamic(() => import('src/modules/shared/modal/components/editBadges/editBadgesModal'), { ssr: false });
const EnrollInProgramModal = dynamic(() => import('src/modules/programs/components/enrollInProgramModal'), { ssr: false });
const GuidelinesAddModal = dynamic(() => import('src/modules/community/communityAbout/components/guidelinesAddModal'), {ssr: false});
const GuidelinesDeleteModal = dynamic(() => import('src/modules/community/communityAbout/components/guidelinesDeleteModal'), {ssr: false});
const GuidelinesInfoModal = dynamic(() => import('src/modules/community/communityAbout/components/guidelinesInfoModal'), {ssr: false});
const IframeModal = dynamic(() => import('src/modules/shared/modal/components/iframeModal'), {ssr: false});
const LostAccessCodeModal = dynamic(() => import('src/modules/local/components/lostAccessCodeModal'), { ssr: false });
const MarketingOptinModal = dynamic(() => import('src/modules/shared/modal/components/marketingOptinModal'), { ssr: false });
const NeedsAssessmentModal = dynamic(() => import('src/modules/needsAssessment/needsAssessmentList/components/needsAssessmentModal'), { ssr: false });
const NeedsAssessmentTipsModal = dynamic(() => import('src/modules/needsAssessment/needsAssessmentReport/components/needsAssessmentTipsModal'), { ssr: false });
const NHSContentModal = dynamic(() => import('src/pages/tag/NHSContentModal'), { ssr: false });
const PrivacyReminderModal = dynamic(() => import('src/modules/community/singlePost/components/privacyReminderModal'), { ssr: false });
const PrivacyTipsImagesModal = dynamic(() => import('src/modules/shared/modal/components/privacyTipsImagesModal'), { ssr: false });
const ProfileSurveyModal = dynamic(() => import('src/modules/profileSurvey/components/profileSurveyModal'), { ssr: false });
const ReplyImageDescriptionModal = dynamic(() => import('src/modules/community/singlePost/components/replyImageDescriptionModal'), { ssr: false });
const ReportModal = dynamic(() => import('src/modules/shared/modal/components/report/reportModal'), { ssr: false });
const SavePostModal = dynamic(() => import('src/modules/community/singlePost/components/SavePostModal'), { ssr: false });
const SubscribeAllPostsModal = dynamic(() => import('src/pages/unsubscribe/subscribeAllPostsModal'), { ssr: false });
const TakeProfileSurveyModal = dynamic(() => import('src/modules/profileSurvey/components/takeProfileSurveyModal'), {ssr: false});
const TakeProfileSurveyOnSignupModal = dynamic(() => import('src/modules/shared/modal/components/signup/profileSurveyOnSignup'), {ssr: false});
const UnsubscribeAllEmailsModal = dynamic(() => import('src/pages/unsubscribe/unsubscribeAllEmailsModal'), { ssr: false });
const WelcomeModal = dynamic(() => import('src/modules/shared/modal/components/signup/welcomeModal'), {ssr: false});
const SelectCommunityToPostModal = dynamic(() => import('src/pages/home/newsfeed/selectCommunityToPostModal'), {ssr: false});

export default function ModalRoot() {
  const dispatch = useDispatch();
  const { modalType, modalProps } = useSelector(({modal}: State) => modal);

  switch (modalType) {
    // Old
    // TOOD: make the old components self dependant? ie. get their props from State and handle closeModal themselves
    case ModalType.DEFAULT:
      return <Modal {...modalProps} closeModal={() => dispatch(closeModal())} />;
    case ModalType.CONFIRM:
      return <ConfirmModal {...modalProps} closeModal={() => dispatch(closeModal())} />;
    case ModalType.DFP:
      return <DFPModal {...modalProps} closeModal={() => dispatch(closeModal())} />;
    case ModalType.EMAIL_CONFIRMATION:
      return <EmailConfirmationModal {...modalProps} closeModal={() => dispatch(closeModal())} />;
    case ModalType.EXISTING_LOGIN_SOCIAL:
      return <ExistingLoginSocialModal />;
    case ModalType.HULOCAL_SIGN_UP:
      return <HuLocalSignupModal />;
    case ModalType.LOGIN:
      return <LoginModal />;
    case ModalType.PRIVACY_TIPS:
      return <PrivacyTipsModal {...modalProps} closeModal={() => dispatch(closeModal())} />;
    case ModalType.FEEDBACK:
      return <FeedbackModal />;
    case ModalType.SEARCH_FILTER_OPTIONS:
      return <FilterOptionsModal {...modalProps} closeModal={() => dispatch(closeModal())} />;
    case ModalType.SEARCH_SORT_BY:
      return <SearchSortByModal {...modalProps} closeModal={() => dispatch(closeModal())} />;
    case ModalType.SENTIMENT_FEEDBACK:
      return <SentimentFeedbackModal {...modalProps} closeModal={() => dispatch(closeModal())} />;
    case ModalType.SIGN_UP_SURVEY:
      return <SignupSurvey {...modalProps} closeModal={() => dispatch(closeModal())} />;
    case ModalType.SIGN_UP:
      return <SignupModal />;
    case ModalType.SIMILAR_TO_ME_TIPS:
      return <SimilarToMeTipsModal {...modalProps} closeModal={() => dispatch(closeModal())} />;
    case ModalType.TAG_FILTER_OPTIONS:
      return <TagFilterOptionsModal {...modalProps} closeModal={() => dispatch(closeModal())} />;
    // New
    case ModalType.COMMUNITY_GUIDELINES:
      return <CommunityGuidelinesModal />;
    case ModalType.COMMUNITY_INVITES:
      return <CommunityInvitesModal />;
    case ModalType.COMMUNITY_TOP_CONDITIONS:
      return <CommunityTopConditionsModal />;
    case ModalType.CONTACT_ADMINS:
      return <ContactAdminsModal />;
    case ModalType.DELETE_POST:
      return <DeletePostModal />;
    case ModalType.EDIT_BADGES:
      return <EditBadgesModal />;
    case ModalType.EMAIL_SUBSCRIBE_ALL_POSTS:
      return <SubscribeAllPostsModal />;
    case ModalType.EMAIL_UNSUBSCRIBE_ALL_EMAILS:
      return <UnsubscribeAllEmailsModal />;
    case ModalType.GUIDELINES_ADD:
      return <GuidelinesAddModal />;
    case ModalType.GUIDELINES_DELETE:
      return <GuidelinesDeleteModal />;
    case ModalType.GUIDELINES_INFO:
      return <GuidelinesInfoModal />;
    case ModalType.IFRAME:
      return <IframeModal />;
    case ModalType.LOST_ACCESS_CODE:
      return <LostAccessCodeModal />;
    case ModalType.MARKETING_OPT_IN:
      return <MarketingOptinModal />;
    case ModalType.NEEDS_ASSESSMENT_TIPS:
      return <NeedsAssessmentTipsModal />;
    case ModalType.NEEDS_ASSESSMENT:
      return <NeedsAssessmentModal />;
    case ModalType.NHS_TAG_CONTENT:
      return <NHSContentModal />;
    case ModalType.PRIVACY_REMINDER:
      return <PrivacyReminderModal />;
    case ModalType.PRIVACY_TIPS_IMAGES:
      return <PrivacyTipsImagesModal />;
    case ModalType.PROFILE_SURVEY:
      return <ProfileSurveyModal />;
    case ModalType.PROGRAM_COMPLETED:
      return <CompletedProgramModal />;
    case ModalType.PROGRAM_ENROLL:
      return <EnrollInProgramModal />;
    case ModalType.REMOVE_MEMBER_FROM_COMMUNITY:
      return <CommunityRemoveMemberModal />;
    case ModalType.REPLY_IMAGE_DESCRIPTION:
      return <ReplyImageDescriptionModal />;
    case ModalType.REPORT:
      return <ReportModal />;
    case ModalType.SAVE_POST:
      return <SavePostModal />;
    case ModalType.TAKE_PROFILE_SURVEY_ON_SIGNUP:
      return <TakeProfileSurveyOnSignupModal />;
    case ModalType.TAKE_PROFILE_SURVEY:
      return <TakeProfileSurveyModal />;
    case ModalType.WELCOME:
      return <WelcomeModal />;
    case ModalType.SELECT_COMMUNITY_TO_POST:
      return <SelectCommunityToPostModal />;
    default:
      return null;
  }
}
